import { render, staticRenderFns } from "./budget-select.vue?vue&type=template&id=5718d515&"
import script from "./budget-select.vue?vue&type=script&lang=js&"
export * from "./budget-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports